import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../components/Form/Field'

import { formatNumber } from '../../../../../../helpers/numbers'

import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { BUDGET_DAILY } from '../../../../../Multiplatform/CampaignForms/fields'
import { getMaxDailyBudget } from '../fields'

const DailyRemainingBudgetFields = ({
  formik,
  remainingBudget,
  startDate,
  endDate,
  initialCampaignBudgetDaily = 0
}) => {
  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedGoogleAdAccountSelector)

  const maxBudgetDaily = getMaxDailyBudget({
    remainingBudget,
    startDate,
    endDate,
    initialCampaignBudgetDaily
  })

  return (
    <FieldLabelWrapper label={t('Daily Budget')} labelFor={BUDGET_DAILY}>
      <p>{t('Set an average amount you want to spend each day.')}</p>

      <p>
        {t(
          `Your total remaining budget is ${currencySymbol}${formatNumber(
            remainingBudget
          )} therefore the maximum daily budget you can enter here is ${currencySymbol}${formatNumber(maxBudgetDaily, {
            max: 2
          })}`
        )}
      </p>
      <Field
        type="number"
        formik={formik}
        name={BUDGET_DAILY}
        placeholder={t('Daily Budget')}
        symbol={currencySymbol}
        autoComplete="off"
        inputMode="numeric"
      />
    </FieldLabelWrapper>
  )
}

export default DailyRemainingBudgetFields
